var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataPresentationSmall-container"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"parameter"},[_c('p',[_c('count-to',{attrs:{"startVal":_vm.startVal,"endVal":_vm.number,"duration":_vm.duration}})],1),_c('span',{staticClass:"unit"},[_vm._v("双")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }